import { render, staticRenderFns } from "./GantiPassword.vue?vue&type=template&id=72c648b7&scoped=true"
import script from "./GantiPassword.vue?vue&type=script&lang=js"
export * from "./GantiPassword.vue?vue&type=script&lang=js"
import style0 from "./GantiPassword.vue?vue&type=style&index=0&id=72c648b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c648b7",
  null
  
)

export default component.exports